import api from './api';
import { DateTime } from 'luxon';

const state = {
	firstPastDay: {},
	firstLockedDay: {},
	dayError: {
		error: false,
		message: '',
	},
};

const getters = {
	toUTCFromLocalDateTime: (state, getters, rootState, rootGetters) => (startDate, startTime) => {
		// Converts a local date and time string to a UTC DateTime object using the user's timezone.
		const timezone = rootGetters['setup/getTimezone'];
		const [hour, minute] = startTime && startTime.includes(':') ? startTime.split(':').map(Number) : [0, 0];
		const date = DateTime.fromISO(startDate, { zone: timezone });

		// Add time portion and convert to UTC
		return date.plus({ hours: hour, minutes: minute }).toUTC();
	},
	getMinStartDate: (state, getters) => () => {
		// Returns the ISO date string (YYYY-MM-DD) of the first past operating day.
		// Used as a baseline for minimum allowed start date.
		return DateTime.fromISO(state.firstPastDay.date).toISODate();
	},
	getMinEndDate: (state, getters) => (startDate) => {
		// Returns the given startDate if provided;
		// otherwise falls back to the minimum start date from firstPastDay.
		return startDate || getters.getMinStartDate();
	},
	isBeforeFirstPastDay: (state, getters) => (startDate, startTime) => {
		// Returns false if no start date is given
		if (!startDate) return false;

		// If no start time is provided, compare just the dates
		if (!startTime) {
			return startDate < getters.getMinStartDate();
		}

		// Convert both the input date/time and the first past day start time to UTC milliseconds
		const firstPastDay = DateTime.fromISO(state.firstPastDay.operatingDayStart).toMillis();
		const startDateTime = getters.toUTCFromLocalDateTime(startDate, startTime).toMillis();

		return startDateTime < firstPastDay;
	},
};

const mutations = {
	setError(state, { message }) {
		(state.dayError.error = true), (state.dayError.message = message);
	},
	setFirstPast(state, firstPastDay) {
		state.firstPastDay = firstPastDay;
	},
	setFirstLocked(state, firstLockedDay) {
		state.firstLockedDay = firstLockedDay;
	},
};

const actions = {
	async loadFirstPastDay({ commit }) {
		try {
			const result = await api.getFirstPastDay();
			commit('setFirstPast', result.data);
		} catch (error) {
			commit('setError', { message: error.response?.data?.message });
		}
	},
	async loadFirstLockedDay({ commit }) {
		try {
			const result = await api.getFirstLockedDay();
			commit('setFirstLocked', result.data);
		} catch (error) {
			commit('setError', { message: error.response?.data?.message });
		}
	},
	async loadDaysByStatus({ commit }, status) {
		try {
			const result = await api.getDaysByStatus(status);
			return result.data;
		} catch (error) {
			commit('setError', { message: error.response?.data?.message });
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
